import {  useState } from "react";
import classNames from "classnames";

import "../styles/playground.css";
import { PvAssembly } from "../components/playground/pv-1";
import { ConnectedPV } from "../components/playground/pv-pic";

export const ProjectPlayground = () => {
    const [gameName, setGameName] = useState("conn-pv");
   return (
    <div className={classNames("min-v")}>
       { gameName === 'pv-1' && <PvAssembly /> }
       {gameName === 'conn-pv' && <ConnectedPV />}
    </div>
   )
}